<script>
import axios from "axios";
import SaveInfo from "./Base/SaveInfo";
import BaseInput from "./Base/BaseInput2";
import DataInputSimple from "./Base/DataInputSimple2";
import BaseLocation from "./Base/BaseLocation2";
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import 'moment-timezone';
import moment from "moment";
import ImageService from "@/services/ImageService";
import ImageRender from "@/components/Base/ImageRender.vue";

export default {
  name: "MyProfile",
  data() {
    return {
      user: null,
      tabNum: 1,
      errors: [],
      checkedFields: [],
      newPassword: "",
      isLoading: true,
      isSubmitted: false,
      isDataUpdating: false,
      imgSrc: '',
      validationRules: [
        {
          'fieldName': 'last_name',
          'isRequired': true,
          'errorText': 'Поле "Фамилия" должно быть заполнено'
        },
        {
          'fieldName': 'first_name',
          'isRequired': true,
          'errorText': 'Поле "Имя" должно быть заполнено'
        },
        {
          'fieldName': 'birthday',
          'isRequired': true,
          'errorText': 'Поле "Дата рождения" должно быть заполнено'
        },
        {
          'fieldName': 'phone',
          'isRequired': true,
          'errorText': 'Поле "Телефон" должно быть заполнено'
        },
        {
          'fieldName': 'birth_country',
          'isRequired': true,
          'errorText': 'Поле "Страна рождения" должно быть заполнено'
        },
        {
          'fieldName': 'birthCity',
          'isRequired': true,
          'errorText': 'Поле "Город рождения" должно быть заполнено'
        },
        {
          'fieldName': 'live_country',
          'isRequired': true,
          'errorText': 'Поле "Страна проживания" должно быть заполнено'
        },
        {
          'fieldName': 'city',
          'isRequired': true,
          'errorText': 'Поле "Город проживания" должно быть заполнено'
        },
        {
          'fieldName': 'speciality',
          'isRequired': true,
          'errorText': 'Поле "Специальность" должно быть заполнено'
        },
        {
          'fieldName': 'about',
          'isRequired': true,
          'errorText': 'Поле "О себе" должно быть заполнено'
        },
        {
          'fieldName': 'education',
          'isRequired': true,
          'errorText': 'Поле "Образование - Образование" должно быть заполнено'
        },
        {
          'fieldName': 'biografy',
          'isRequired': true,
          'errorText': 'Поле "Профессиональный опыт - Биография" должно быть заполнено'
        },
        {
          'fieldName': 'data_accept',
          'parentEntity': 'user_data',
          'isRequired': true,
          'errorText': 'Поле "Подвердите согласие на предоставление личных данных" должно быть заполнено'
        },
        {
          'fieldName': 'info_right',
          'parentEntity': 'user_data',
          'isRequired': true,
          'errorText': 'Поле "Вся предоставленная Вами информация достоверна и соответствует действительности" должно быть заполнено'
        }
      ],
      countriesinput: [],
      currentInput: '',
      educations: [],
      needCheck: false
    }
  },
  components: {
    SaveInfo,
    BaseInput,
    DataInputSimple,
    BaseLocation,
    VueCropper,
    ImageRender
  },
  mounted: function () {
    const params = this.getQueryParams(window.location.search);
    if (params.tab) {
      this.changeCurrentTab(parseInt(params.tab));
    }
    if (params.check) {
      this.needCheck = true;
    }

    //window.getQueryParams(document.location.search)
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }
    this.getData();
    this.getEducations();
  },
  methods: {
    getQueryParams(qs) {
      qs = qs.split('+').join(' ');

      var params = {};
      var tokens;
      var re = /[?&]?([^=]+)=([^&]*)/g;

      // eslint-disable-next-line no-cond-assign
      while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
      }

      return params;
    },
    getData: function () {
      const self = this;
      if (!self.isDataUpdating) {
        self.isLoading = true;
      }
      axios.get('/api/users/' + window.userId, {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          self.user = response.data;
          if (response.data?.user_data === null) {
            response.data.user_data = {};
          }
          if (Array.isArray(response.data?.user_data) && response.data?.user_data.length === 0) {
            response.data.user_data = {};
          }
          if (response.data?.user_data?.opit_festival === undefined) {
            response.data.user_data.opit_festival = '';
          }
          if (response.data?.user_data?.videovizitka === undefined) {
            response.data.user_data.videovizitka = '';
          }
          if (response.data?.user_data?.data_accept === undefined) {
            response.data.user_data.data_accept = false;
          }
          if (response.data?.user_data?.info_right === undefined) {
            response.data.user_data.info_right = false;
          }
          if (response.data?.user_data?.showrill === undefined) {
            response.data.user_data.showrill = '';
          }
          if (response.data?.user_data?.catalogFields === undefined) {
            response.data.user_data.catalogFields = {
              'last_name': false,
              'first_name': false,
              'patronymic': false,
              'nickname': false,
              'email': false,
              'birthday': false,
              'phone': false,
              'birth_country': false,
              'birthCity': false,
              'region': false,
              'live_country': false,
              'city': false,
              'live_region': false,
              'speciality': false,
              'socialLinks': false,
              'site': false,
              'about': false,
              'opit_festival': false,
              'videovizitka': false,
              'showrill': false
            };
          }

          self.isLoading = false;
          self.isDataUpdating = false;

          if (self.countriesinput.length === 0) {
            self.loadCountries();
          }
          if (this.needCheck) {
            this.checkErrors();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onSubmit() {
      this.checkErrors();
    },
    saveData: function () {
      let self = this;
      if (!this.isDataUpdating) {
        this.isDataUpdating = true;
        axios.patch('/api/users/' + window.userId,
          {
            'lastName': this.user.last_name,
            'firstName': this.user.first_name,
            'patronymic': this.user.patronymic,
            'nickname': this.user.nickname,
            'email': this.user.email,
            'birthday': this.user.birthday?.length > 0 ? moment.tz(this.user.birthday, "Europe/Moscow").format() : null,
            'phone': this.user.phone,
            'birthCountry': this.user.birth_country,
            'birthCity': this.user.birthCity,
            'region': this.user.region,
            'liveCountry': this.user.live_country,
            'liveRegion': this.user.live_region,
            'city': this.user.city,
            'speciality': this.user.speciality,
            'socialLinks': this.user.socialLinks,
            'site': this.user.site,
            'about': this.user.about,
            'education': this.user.education,
            //'schollName': this.user.scholl_name,
            'additionalEducation': this.user.additional_education,
            'showContactInfo': this.user.showContactInfo,
            'biografy': this.user.biografy,
            'partproject': this.user.partproject,
            'userData': this.user.user_data
          },
          {
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/merge-patch+json',
            }
          }
        ).then((response) => {
          if (response.headers['content-type'] === 'text/html; charset=UTF-8') {
            alert('Время соединения истекло. Войдите повторно в свой аккаунт.');
            window.location.reload();
          }
          if (self.isSubmitted) {
            self.checkErrors(false);
          }
          self.getData()
          self.isSubmitted = true;
        }).catch(error => {
          console.log(error);
          alert('Ошибка получения данных')
        });
      }

    },

    get_uploaded_image_asset(path) {
      return ImageService.getCompetitionImagePath(path);
    },
    loadCountries() {
      const self = this;
      axios.get('/get_all_countries', {
        headers: {
          'Accept': 'application/json',
        }
      })
        .then(response => {
          self.countriesinput = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeCurrentTab(num) {
      this.tabNum = num;
    },
    saveNewPassword() {
      let self = this;
      window.$.ajax({
        dataType: "json",
        type: 'post',
        data: {
          plainPassword: this.newPassword
        },
        url: '/change_profile_password',
        success: function () {
          self.newPassword = '';
          alert('Сохранено');
        },
        error: function (data) {
          alert('Ошибка получения данных' + data);
        }
      });
    },
    loadCities() {
      const self = this;
      const current_country = self.countriesinput.filter(function (el) {
        return el["ru_name"] === self.project.country;
      })
      if (current_country[0] && current_country[0].number) {
        axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });
      return res;
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Загрузить можно только изображение");
        return;
      }
      if (file.size > 5242880) {
        alert("Максимальный размер изображения 5 мегабайта. Обработайте изображение в графических редакторах, чтобы уменьшить его размер.");
        return;
      }
      this.origfilename = file.name;
      const self = this;
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          self.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          if (self.$refs.cropper) {
            self.$refs.cropper.replace(event.target.result);
          }
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    cropImage() {
      const self = this;
      this.$refs.cropper.getCroppedCanvas('getCroppedCanvas').toBlob(function (blob) {
        let formData = new FormData();
        formData.append('file', blob);
        formData.append('original-name', self.origfilename);
        formData.append('current-name', self.user.avatar);

        formData.append('entity-id', self.user.id);

        axios(
          {
            method: 'post',
            url: '/setUserAvatar',
            data: formData
          }
        )
          .then(() => {
            self.imgSrc = '';
            self.getData();
          });
      })
    },
    addEducation() {
      const self = this;
      window.$.ajax({
        dataType: "json",
        type: 'post',
        data: {
          tag_name: this.currentInput
        },
        url: '/add_user_education',
        success: function (data) {
          self.educations = data;
          self.currentInput = '';
        },
        error: function () {
          alert('Ошибка получения данных');
        }
      });
    },
    removeEducation(tag_name) {
      const self = this;
      window.$.ajax({
        dataType: "json",
        type: 'post',
        data: {
          tag_name: tag_name
        },
        url: '/remove_user_education',
        success: function (data) {
          self.educations = data;
          self.currentInput = '';
        },
        error: function () {
          alert('Ошибка получения данных');
        }
      });
    },
    getEducations() {
      const self = this;
      window.$.ajax({
        dataType: "json",
        type: 'get',
        contentType: "application/ld+json;",
        url: '/get_user_education',
        success: function (data) {
          self.educations = data;
        },
        error: function () {
          alert('Ошибка получения данных');
        }
      });
    },
    addProject() {
      this.user.partproject.push({
        feature: '',
        link: '',
        name: '',
        role: '',
        year: '',
      })
    },
    removeProject(index) {
      this.user.partproject = this.user.partproject.filter(function (el, inner_index) {
        return inner_index !== index;
      });
      this.saveData();
    },
    validateField(field) {
      const self = this;
      if (field.parentEntity !== undefined) {
        if (field.isRequired && (self.user[field.parentEntity] === null || self.user[field.parentEntity][field.fieldName] === undefined || (self.user[field.parentEntity][field.fieldName] === null || self.user[field.parentEntity][field.fieldName].length === 0 || self.user[field.parentEntity][field.fieldName] === false || self.user[field.parentEntity][field.fieldName] === 0))) {
          if (!self.errors.includes(field.errorText)) {
            self.errors.push(field.errorText);
          }
        }
      } else {
        if (field.isRequired && (self.user[field.fieldName] === null || self.user[field.fieldName].length === 0 || self.user[field.fieldName] === 0)) {
          if (!self.errors.includes(field.errorText)) {
            self.errors.push(field.errorText);
          }
        }
      }
    },
    checkErrors(withScroll = true) {
      const self = this;
      this.needCheck = false;
      self.errors = [];
      this.validationRules.forEach(function (field) {
        self.validateField(field)
      });
      if (withScroll) {
        if (self.errors.length > 0) {
          document.getElementById("user_form").scrollIntoView();
        }
      }
    },
    getFieldLabel(key) {
      // Словарь для перевода ключей полей в удобочитаемые метки
      const labels = {
        last_name: 'Фамилия',
        first_name: 'Имя',
        patronymic: 'Отчество',
        nickname: 'Псевдоним',
        email: 'Email',
        birthday: 'Дата рождения',
        phone: 'Телефон',
        birth_country: 'Страна рождения',
        birthCity: 'Город рождения',
        region: 'Регион',
        live_country: 'Страна проживания',
        city: 'Город проживания',
        live_region: 'Регион проживания',
        speciality: 'Специальность',
        socialLinks: 'Ссылки на соцсети',
        site: 'Сайт',
        about: 'О себе',
        opit_festival: 'Опыт участия в фестивалях',
        videovizitka: 'Видеовизитка',
        showrill: 'Шоурил'
      };
      return labels[key] || key;
    },
    handleCheckboxChange(checkedValues) {
      this.saveData();
    },
  }
}
</script>

<template>
  <div>
    <SaveInfo
        :isDataUpdating="isDataUpdating"
    />
    <div class="tabs">
      <ul>
        <li @click="changeCurrentTab(1)" class="tab tab1" :class="tabNum === 1 ? 'is-active' : ''"><a>Личные данные</a>
        </li>
        <li @click="changeCurrentTab(2)" class="tab tab2" :class="tabNum === 2 ? 'is-active' : ''"><a>Образование</a>
        </li>
        <li @click="changeCurrentTab(3)" class="tab tab3" :class="tabNum === 3 ? 'is-active' : ''"><a>Профессиональный
          опыт</a></li>
        <li @click="changeCurrentTab(4)" class="tab tab4" :class="tabNum === 4 ? 'is-active' : ''"><a>Приватность</a>
        </li>
        <li @click="changeCurrentTab(5)" class="tab tab5" :class="tabNum === 5 ? 'is-active' : ''"><a>Для каталога</a>
        </li>
      </ul>
    </div>
    <div v-if="!isLoading && user !== null">
      <form id="user_form" name="user_form" @submit.prevent="onSubmit">
        <div class="errors-block" v-if="errors.length">
          <b>Пожалуйста, заполните обязательные поля</b>
          <ul>
            <li v-for="(error,index) in errors" :key="index" v-html="error"></li>
          </ul>
        </div>
        <div v-if="tabNum === 1" class="content-tab">
          <div class="columns">
            <div class="column">
              <BaseInput
                  label="Фамилия"
                  v-model="user.last_name"
                  objectKey="last_name"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Имя"
                  v-model="user.first_name"
                  objectKey="first_name"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Отчество"
                  v-model="user.patronymic"
                  objectKey="patronymic"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Псевдоним"
                  v-model="user.nickname"
                  objectKey="nickname"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Email"
                  v-model="user.email"
                  objectKey="email"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <DataInputSimple
                  v-model="user.birthday"
                  keyData="birthday"
                  label="Дата рождения"
                  :isDataUpdating="isDataUpdating"
              ></DataInputSimple>
              <BaseInput
                  label="Телефон"
                  v-model="user.phone"
                  objectKey="phone"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseLocation
                  v-if="user !== null && countriesinput.length > 0"
                  :countriesinput="countriesinput"
                  :isDataUpdating="isDataUpdating"
                  countryKey="birth_country"
                  cityKey="birthCity"
                  regionKey="region"
                  labelCountry="Страна рождения"
                  labelCity="Город рождения"
                  labelRegion="Регион рождения"
              ></BaseLocation>

              <BaseLocation
                  v-if="user !== null && countriesinput.length > 0"
                  :countriesinput="countriesinput"
                  :isDataUpdating="isDataUpdating"
                  countryKey="live_country"
                  cityKey="city"
                  regionKey="live_region"
                  labelCountry="Страна проживания"
                  labelCity="Город проживания"
                  labelRegion="Регион проживания"
              ></BaseLocation>

              <div class="field">
                <label :class="this.isFieldRequired('opit_festival') ? 'req': ''" for="user_opit_festival">Опыт участия
                  в фестивалях, питчингах</label>
                <textarea :disabled="isDataUpdating" @change="saveData" v-model="user.user_data.opit_festival"
                          id="user_opit_festival"></textarea>
              </div>

              <div class="field">
                <label :class="this.isFieldRequired('videovizitka') ? 'req': ''" for="user_videovizitka">Видеовизитка
                  (по-возможности)</label>
                <textarea :disabled="isDataUpdating" @change="saveData" v-model="user.user_data.videovizitka"
                          id="user_videovizitka"></textarea>
              </div>

              <BaseInput
                  label="Ссылка на шоурил творческих работ"
                  v-model="user.user_data.showrill"
                  objectKey="showrill"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
            </div>
            <div class="column">
              <BaseInput
                  label="Специальность"
                  v-model="user.speciality"
                  objectKey="speciality"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Ссылки на соцсети"
                  v-model="user.socialLinks"
                  objectKey="socialLinks"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>
              <BaseInput
                  label="Ссылка на сайт"
                  v-model="user.site"
                  objectKey="site"
                  :isDataUpdated="isDataUpdating"
                  :isFormSubmitted="isSubmitted"
              ></BaseInput>

              <div class="field">
                <label :class="this.isFieldRequired('about') ? 'req': ''" for="user_about">О себе</label>
                <p class="primechanie">Тут вы можете указать что-то особенное о себе. То что выделит вас, то о чем вы
                  знаете лучше чем другие. Например: прожили пять лет в Испании, знаете иностранные языки, проработали
                  10 лет на Космодроме Байконур и т.п.</p>
                <textarea id="user_about" :disabled="isDataUpdating" @change="saveData" v-model="user.about"></textarea>
              </div>

              <div class="field">
                <label>Изображение профиля</label>

                <div v-if="user.avatar" class="avatar_image">
                  <!--                  <img :src="'/uploads/images/' + user.avatar" id="image">-->
                  <ImageRender
                      :id="'image'"
                      :src="get_uploaded_image_asset(user.avatar)"
                  ></ImageRender>
                </div>

                <i class="fas fa-download"></i>
                <input :disabled="isDataUpdating" type="file" accept="image/*" @change="setImage">
                <div id="fileList"></div>
                <vue-cropper
                    ref="cropper"
                    :src="imgSrc"
                    alt="Source Image"
                    :aspect-ratio="500 / 500"
                    preview=".preview"
                    v-if="imgSrc != ''"
                >
                </vue-cropper>
                <button class="button2" @click.prevent="cropImage" v-if="imgSrc != ''">Сохранить изображение</button>
              </div>

              <div class="field">
                <label for="user_edit_plainPassword">Пароль (оставьте пустым, если не требуется изменение)</label>
                <input type="text" id="user_edit_plainPassword" name="user_edit[plainPassword]" v-model="newPassword">

                <button style="margin-top: 20px;" class="button2" @click.prevent="saveNewPassword">Сохранить пароль
                </button>
              </div>

            </div>
          </div>
        </div>
        <div v-if="tabNum === 2" class="content-tab">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label :class="this.isFieldRequired('education') ? 'req': ''">Образование</label>
                <div class="select-field">
                  <select :disabled="isDataUpdating" @change="saveData" v-model="user.education">
                    <option value="Среднее">Среднее</option>
                    <option value="Среднее профессиональное">Среднее профессиональное</option>
                    <option value="Начальное профессиональное">Начальное профессиональное</option>
                    <option value="Студент">Студент</option>
                    <option value="Высшее" selected="selected">Высшее</option>
                  </select>
                </div>
                <div class="field">
                  <label for="base_education">Основное образование</label>
                  <input v-model="currentInput" type="text" id="base_education" name="base_education" maxlength="255">
                </div>
                <p>
                  <button @click.prevent="addEducation">Добавить</button>
                </p>
                <ul>
                  <li v-for="item in educations" :key="item.id">
                    {{ item }} <i style="margin-left: 20px; cursor: pointer;" @click="removeEducation(item)"
                                  class="fas fa-trash"></i>
                  </li>
                </ul>

                <!--                <BaseInput-->
                <!--                    label="Название учебного заведения"-->
                <!--                    v-model="user.scholl_name"-->
                <!--                    objectKey="scholl_name"-->
                <!--                    :isDataUpdated="isDataUpdating"-->
                <!--                    :isFormSubmitted="isSubmitted"-->
                <!--                ></BaseInput>-->

                <div class="field">
                  <label :class="this.isFieldRequired('additional_education') ? 'req': ''"
                         for="user_additional_education">Дополнительное образование</label>
                  <textarea :disabled="isDataUpdating" @change="saveData" v-model="user.additional_education"
                            id="user_additional_education"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tabNum === 3" class="content-tab">
          <div class="columns">
            <div class="column">
              <div class="partprojects">
                <div v-for="(pp, index) in user.partproject" class="partproject_item" :key="index">
                  <div class="field"><label>Название проекта</label>
                    <input :disabled="isDataUpdating" @change="saveData" type="text" maxlength="255"
                           v-model="user.partproject[index].name">
                  </div>
                  <div class="field">
                    <label>Год реализации</label>
                    <input :disabled="isDataUpdating" @change="saveData" type="text" maxlength="255"
                           v-model="user.partproject[index].year">
                  </div>
                  <div class="field">
                    <label>Роль на проекте</label>
                    <input :disabled="isDataUpdating" @change="saveData" type="text" maxlength="255"
                           v-model="user.partproject[index].role">
                  </div>
                  <div class="field">
                    <label>Ссылка на информацию о проекте</label>
                    <input :disabled="isDataUpdating" @change="saveData" type="text" maxlength="255"
                           v-model="user.partproject[index].link">
                  </div>
                  <div class="field">
                    <label>Особенности проекта</label>
                    <textarea :disabled="isDataUpdating" @change="saveData"
                              placeholder="Напишите, что отличает этот проект. Например, эта студенческая работа, в который приняли участие кинозвезды или проект- победитель конкурсов."
                              v-model="user.partproject[index].feature"></textarea>
                  </div>
                  <a @click="removeProject(index)" class="buttonmini" type="button"><i class="fas fa-trash-alt"></i>
                    Удалить проект</a>
                </div>
                <a @click="addProject" class="button2 add_item_link" data-collection-holder-class="partprojects">Добавить
                  проект</a>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label :class="this.isFieldRequired('biografy') ? 'req': ''"
                       for="user_biografy">Биография</label>
                <textarea :disabled="isDataUpdating" @change="saveData" v-model="user.biografy"
                          id="user_biografy"></textarea>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tabNum === 4" class="content-tab">
          <div class="columns">
            <div class="column">
              <p class="checkbox__wrapper" style="margin-bottom: 30px">
                <input :disabled="isDataUpdating" @change="saveData" v-model="user.showContactInfo" type="checkbox"
                       id="project_noCommand" name="project[noCommand]"><label for="project_noCommand" class="required">Ставя
                галочку, я понимаю и соглашаюсь с тем, что, моя личная страница (включая мои контактные данные), на
                платформе КиноКластер Мувистарт будет доступна для всех пользователей сети интернет.*</label>
              </p>
              <p style="text-align: right"><span style="font-size: 14px; color:#4a4a4a;">* Для проекта  "Межрегиональный кинорезерв творческой молодежи"</span>
              </p>
            </div>
          </div>
        </div>
        <div v-if="tabNum === 5" class="content-tab">
          <div class="columns">
            <div class="column">
              <div v-for="(value, key) in user.user_data.catalogFields" :key="key" class="field">
                <a-checkbox v-model:checked="user.user_data.catalogFields[key]" @change="handleCheckboxChange">
                  {{ getFieldLabel(key) }}
                </a-checkbox>
              </div>
            </div>
          </div>
        </div>

        <div class="field checkbox__wrapper">
          <input @change="saveData" type="checkbox" id="user_edit_data_accept" required="required"
                 data-jsontype="data-jsontype" v-model="user.user_data.data_accept">
          <label class="req required" for="user_edit_data_accept">Подвердите согласие на предоставление личных
            данных</label>
        </div>

        <div class="field checkbox__wrapper">
          <input @change="saveData" type="checkbox" id="user_edit[info_right]" required="required"
                 data-jsontype="data-jsontype" v-model="user.user_data.info_right">
          <label class="req required" for="user_edit[info_right]">Вся предоставленная Вами информация достоверна и
            соответствует действительности</label>
        </div>

        <!--        <p><input type="button" @click="checkErrors" class="button2" value="Опубликовать"></p>-->

      </form>
    </div>
    <div v-else style="text-align: center; margin-top: 20px;">
      <a-spin/>
    </div>
  </div>
</template>

<style scoped>
.primechanie {
    font-size: 13px;
    text-align: justify;
}

.avatar_image:deep #image {
    max-width: 200px;
    margin-top: 20px;
    margin-bottom: 20px;
}

.errors-block {
    color: red;
    border: 1px solid #999;
    border-radius: 10px;
    padding: 25px;
    margin-bottom: 30px;
}

.partproject_item {
    border: 1px solid silver;
    padding: 25px;
    padding-top: 0;
    border-radius: 10px;
    margin-bottom: 20px;
}

.lds-default {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(0.5);
    text-align: center;
}

.lds-default div {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #000;
    border-radius: 50%;
    animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
    animation-delay: 0s;
    top: 37px;
    left: 66px;
}

.lds-default div:nth-child(2) {
    animation-delay: -0.1s;
    top: 22px;
    left: 62px;
}

.lds-default div:nth-child(3) {
    animation-delay: -0.2s;
    top: 11px;
    left: 52px;
}

.lds-default div:nth-child(4) {
    animation-delay: -0.3s;
    top: 7px;
    left: 37px;
}

.lds-default div:nth-child(5) {
    animation-delay: -0.4s;
    top: 11px;
    left: 22px;
}

.lds-default div:nth-child(6) {
    animation-delay: -0.5s;
    top: 22px;
    left: 11px;
}

.lds-default div:nth-child(7) {
    animation-delay: -0.6s;
    top: 37px;
    left: 7px;
}

.lds-default div:nth-child(8) {
    animation-delay: -0.7s;
    top: 52px;
    left: 11px;
}

.lds-default div:nth-child(9) {
    animation-delay: -0.8s;
    top: 62px;
    left: 22px;
}

.lds-default div:nth-child(10) {
    animation-delay: -0.9s;
    top: 66px;
    left: 37px;
}

.lds-default div:nth-child(11) {
    animation-delay: -1s;
    top: 62px;
    left: 52px;
}

.lds-default div:nth-child(12) {
    animation-delay: -1.1s;
    top: 52px;
    left: 62px;
}

@keyframes lds-default {
    0%, 20%, 80%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.5);
    }
}
</style>